export default {
    API_URL: 'https://api.datinglove.vip/api',
    SOCKET_API_URL: 'https://realtime.datinglove.vip',
    WEBSITE_URL: 'https://datinglove.vip',
};
